import { createApp, h } from 'vue';
import {createInertiaApp, Link} from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from 'ziggy';
import { createI18n } from 'vue-i18n';
import GoogleTagManager from './Plugins/GoogleTagManager';
import Layout from './Layout/Default.vue';
import Head from './Layout/Components/Head.vue';
import '../css/app.scss';

import en from './lang/en.json';
import de from './lang/de.json';
import nl from './lang/nl.json';

const languages = {
  'en': en,
  'de': de,
  'nl': nl,
};
/*
|--------------------------------------------------------------------------
| Setup Google Tag Manager
|--------------------------------------------------------------------------
*/
function pushDataLayer(data) {
  setTimeout(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  });
}

createInertiaApp({
  resolve: name => {
    const path = `./Pages/${name}.vue`;
    return resolvePageComponent(path, import.meta.glob('./Pages/**/*.vue', { eager: true }))
      .then(page => {
        if (page.default.layout === undefined) {
          page.default.layout = Layout;
        }
        return page;
      });
  },
  async setup({ el, App, props, plugin }) {
    const i18n = createI18n({
      locale: 'en',
      fallbackLocale: 'en',
      messages: {'en': languages[props.initialPage.props.country]},
    });

    const ssrWorking = el.childNodes.length > 0;
    if (!props.initialPage.props.isProduction && !ssrWorking) {
      if (!props.initialPage.props.inertiaIsEnabled) {
        console.info('[dev] SSR not working, but is not enabled.');
      } else {
        const error = 'app.js - SSR not working?! Check the (docker) logs for any SSR error. Preventing the app from client-side rendering.';
        console.error(error);

        const errorElement = document.createElement('div');
        errorElement.innerHTML = `<h1><b>${error}</b></h1>`;
        el.appendChild(errorElement);

        throw error;
      }
    }

    const app = createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(ZiggyVue)
      .use(GoogleTagManager)
      .use(i18n)
      .mixin({
        methods: {
          route: (name, params, absolute, config = window.Ziggy) => window.route(name, params, absolute, config),
          localeRoute(name, params, absolute, config = window.Ziggy) {
            return this.route(`${this.$page.props.country}.${name}`, params, absolute, config);
          },
          __(key, options) {
            return this.$t(key, options);
          },
          pushDataLayer,
        },
      })
      .component('Head', Head)
      .component('Link', Link);

    const isDesktop = window.matchMedia('screen and (min-width: 1025px)').matches;
    app.config.globalProperties.$isDesktop = isDesktop;
    app.provide('$isDesktop', isDesktop);

    app.mount(el);

    pushDataLayer({
      originalLocation: document.location.protocol + '//' +
        document.location.hostname +
        document.location.pathname +
        document.location.search,
    });
  },
});
